import { Controller } from "@hotwired/stimulus"

// Plus One Toggle Controller
// Handles showing/hiding plus one name field when checkbox is toggled
export default class extends Controller {
  static targets = ["checkbox", "nameField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isChecked = this.checkboxTarget.checked
    
    if (isChecked) {
      this.nameFieldTarget.classList.remove("hidden")
      // Focus on the name field when shown
      const nameInput = this.nameFieldTarget.querySelector("input")
      if (nameInput) {
        setTimeout(() => nameInput.focus(), 100)
      }
    } else {
      this.nameFieldTarget.classList.add("hidden")
      // Clear the field when hidden
      const nameInput = this.nameFieldTarget.querySelector("input")
      if (nameInput) {
        nameInput.value = ""
      }
    }
  }
}